import { CustomButton, CustomCollapseCard, CustomTable, Text } from '@src/components';
import React, { useCallback, useEffect, useState } from 'react';
import { DownCircleOutlined, UpCircleOutlined } from '@ant-design/icons';
import dayjs from '@src/utils/day';
import { moneyFormat } from '@src/utils/utils';
import { orderGetPageList, setSelectedOrder } from '@src/store/slice/orderSlice';
import { useDispatch, useSelector } from 'react-redux';
import '@src/styles/pendingApproval/balanceOrder.scss';
import OrderSummaryBalanceModal from '@src/pages/ticketRestaurant/myOrders/OrderSummaryBalanceModal';

function getExpandIcon() {
  return ({ expanded, onExpand, record }) =>
    expanded ? (
      <UpCircleOutlined style={{ fontSize: '24px' }} onClick={(e) => onExpand(record, e)} />
    ) : (
      <DownCircleOutlined style={{ fontSize: '24px' }} onClick={(e) => onExpand(record, e)} />
    );
}

function getExpandedRowRender() {
  return (record) => (
    <div className="custom-expanded-row" key={record.id}>
      <div className="colum-title">
        <span>
          <Text t="transactionDate" />
        </span>{' '}
        <span>{dayjs(record.orderDate).format('DD/MM/YYYY hh:mm')}</span>
      </div>
      <div className="colum-title">
        <span>
          <Text t="numberOfCards" />
        </span>{' '}
        <span>{record.totalCount}</span>
      </div>
      <div className="colum-title">
        <span>SİPARİŞ TUTARI:</span> <span>{record.totalPrice} TL</span>
      </div>

      <div className="mobile-action-btn pending-payment">
        <CustomButton
          id="pendingPayment-paymentList-custom-btn-payment"
          className="custom-btn-payment"
        >
          <Text t="pay" />
        </CustomButton>
      </div>
    </div>
  );
}

const PaymentList = () => {
  const dispatch = useDispatch();

  const { selectedCustomer } = useSelector((state) => state?.customer);
  const { list, tableProperty } = useSelector((state) => state?.order);

  const [expandedRows, setExpandedRows] = useState([]);
  const [orderSummaryBalanceModalVisible, setOrderSummaryBalanceModalVisible] = useState(false);

  useEffect(() => {
    loadPaymentList();
  }, []);

  const loadPaymentList = useCallback(() => {
    const body = {
      customerId: selectedCustomer?.customerId,
      vouId: 1,
      paymentResult: false,
      orderTypeId: 10,
    };

    dispatch(orderGetPageList({ body, pageNumber: 1, pageSize: 10 }));
  }, [dispatch, selectedCustomer?.customerId]);

  const handleCardTableChange = useCallback(
    (pageNumber, pageSize) => {
      const body = {
        customerId: selectedCustomer?.customerId,
        vouId: 1,
        paymentResult: false,
        orderTypeId: 10,
      };
      dispatch(orderGetPageList({ body, pageNumber, pageSize }));
    },
    [dispatch, selectedCustomer?.customerId],
  );

  const handleCardDetail = (record) => {
    dispatch(setSelectedOrder(record));
    setOrderSummaryBalanceModalVisible(true);
  };

  const columnsPayment = [
    {
      title: <Text t="orderNoUpperCase" />,
      dataIndex: 'id',
      key: 'id',
      width: '20%',
      render: (text, record) => {
        return (
          <div className="balance-order-list-order-number" onClick={() => handleCardDetail(record)}>
            {text}
          </div>
        );
      },
    },
    {
      title: <Text t="actionBy" />,
      dataIndex: 'createdUser',
      key: 'createdUser',
      width: '20%',
    },
    {
      title: <Text t="transactionDate2" />,
      dataIndex: 'orderDate',
      key: 'orderDate',
      width: '20%',
      responsive: ['md'],
      render: (text) => {
        return (
          <div>
            <div>{dayjs(text).format('DD/MM/YYYY hh:mm')}</div>
          </div>
        );
      },
    },
    {
      title: <Text t="numberOfCard3" />,
      dataIndex: 'totalCount',
      key: 'totalCount',
      width: '20%',
      responsive: ['md'],
    },
    {
      title: <Text t="orderPrice" />,
      dataIndex: 'totalPrice',
      key: 'totalPrice',
      width: '20%',
      responsive: ['md'],
      render: (text) => <span>{text ? `${moneyFormat(text, false)} TL` : '0'}</span>,
    },
    {
      title: '',
      dataIndex: 'action',
      key: 'action',
      align: 'center',
      width: '40%',
      responsive: ['md'],
      render: (_, record) => {
        return (
          <div className="row-btn-actions">
            <CustomButton
              id="pendingPayment-paymentList-second-custom-btn-payment"
              className="custom-btn-payment"
            />
          </div>
        );
      },
    },
  ];

  return (
    <CustomCollapseCard className="card-order-card">
      <CustomTable
        pagination={
          tableProperty?.totalCount > 10
            ? {
                total: tableProperty?.totalCount,
                pageSize: tableProperty?.pageSize,
                current: tableProperty?.currentPage,
                onChange: (pageNumber, pageSize) => handleCardTableChange(pageNumber, pageSize),
                defaultCurrent: 1,
              }
            : false
        }
        isScroll={false}
        dataSource={list}
        columns={columnsPayment}
        rowKey={(record) => `list-${record?.id}`}
        expandedRowKeys={expandedRows}
        expandable={{
          showExpandColumn: false,
          expandIconColumnIndex: 7,
          onExpand: (expanded, record, key) =>
            expandedRows === key ? setExpandedRows(null) : setExpandedRows(key),
          expandIcon: getExpandIcon(),
          expandedRowRender: getExpandedRowRender(),
        }}
      />
      <OrderSummaryBalanceModal
        modalVisible={orderSummaryBalanceModalVisible}
        handleModalVisible={setOrderSummaryBalanceModalVisible}
      />
    </CustomCollapseCard>
  );
};

export default PaymentList;
